module.exports = __webpack_public_path__ + "static/media/sad2.da55ee08.svg";